import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon_caret_left",
  "use": "icon-icon_caret_left-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_caret_left\"><defs><style></style></defs><path d=\"M702.669 148.48l-409.6 346.726a21.914 21.914 0 0 0 0 33.383l409.6 346.726a21.914 21.914 0 0 0 36.045-16.793V165.274a21.914 21.914 0 0 0-36.045-16.794z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol